@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.voiceassistant

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.voiceassistant.VoiceAssistantConnectionHealthDto
import com.narbase.letsgo.web.dto.voiceassistant.VoiceAssistantSettingsDto

object CheckVoiceAssistantModelsHealthEndpoint :
    EndPoint<CheckVoiceAssistantModelsHealthEndpoint.Request, CheckVoiceAssistantModelsHealthEndpoint.Response>() {
    class Request(val settings: VoiceAssistantSettingsDto)
    class Response(
        val chat: VoiceAssistantConnectionHealthDto,
        val transcription: VoiceAssistantConnectionHealthDto,
        val isEnabled: Boolean,
        val modelsSuspendedReason: String?,
    )
}
